// Module
var code = "<html> <head> <title>$FILENAME$.pdf</title> </head> <body style=\"margin:0\"> <iframe style=\"border:0\" width=\"100%\" height=\"100%\" src=\"data:application/pdf;base64,$DATA$\"></iframe> </body> </html> ";
// Exports
module.exports = code;